import { Center, CenterProps } from '@chakra-ui/react';
import React from 'react';
import { wellStyles } from './styles/Well.styles';

export default function Well(props: CenterProps) {
  return <Center {...wellStyles.wrapper} {...props} />;
}
